enum SessionFlowTypes {
	duplicateFlow = "duplicateFlow",
	newFlow = "newFlow"
}

export default SessionFlowTypes